import axios from 'axios';
import { currentToken } from '~/common/auth';
import qs from 'qs';

const requestHeaders = () => {
  return currentToken()
    .then(token => {
      let header = {
        authorization: 'Bearer ' + token,
      };

      return header;
    })
    .catch(err => {
      if (err.code === 'NotAuthorizedException') {
        console.error(err);
      }
    });
};

const MoodJournalService = {
  async fetchJournals({ memberId, startDate, endDate, timezone, coachRole }) {
    const params = {
      from: startDate,
      to: endDate,
      timezone,
      coachRole,
      memberId,
    };

    const headers = await requestHeaders();

    try {
      const { data } = await axios.get(
        `${
          process.env.NALURI_APP_COACH_PLATFORM_API_GATEWAY
        }/arctic/journal/mood/log?${qs.stringify(params)}`,
        {
          headers,
        },
      );

      return data;
    } catch (error) {
      console.error({
        error,
      });
      return;
    }
  },
};

export default MoodJournalService;



// WEBPACK FOOTER //
// ./src/features/mood-journal/services/MoodJournalService.js